import Obra from './Obra';

export default Obra;